import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_FOLDER_LIST = graphql(`
  query GetFolderList {
    uploadFolders(destination: CLAIMS) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          name
          label
          destination
        }
      }
    }
  }
`);

export function useGetFolderList() {
  const { loading, data, error } = useQuery(GET_FOLDER_LIST);

  return {
    loading,
    error,
    data,
  };
}
